export default {
  login: {
    title: 'Login',
    usernameLabel: 'Username',
    usernamePlaceholder: '2-10 English digit',
    loginPasswordLabel: 'Login password',
    loginPasswordPlaceholder: 'Please enter your login password',
    googleCodeLabel: 'Google verification code',
    googleCodePlaceholder: 'Please enter a 6-digit Google verification code',
    hasNoAccount: 'No account yet,',
    goRegister: 'Go to register',
    onlineCustom: 'Online customer service',
    loginArgument: 'Continuing to log in means agreeing',
    userArgument: '《User Agreement》',
    registerNotEnabled: 'The registration function is not open, please contact the administrator',
    usernameRequired: 'Please enter a correct username',
    loginPasswordRequired: 'Please enter the correct login password',
    googleCodeRequired: 'Please enter the correct Google verification code',
    loginButton: 'login'
  },
  register: {
    title: 'Register',
    usernameLabel: 'Username',
    usernamePlaceholder: 'Please enter the registered username',
    loginPasswordLabel: 'Login password',
    loginPasswordPlaceholder: 'Please enter the login password of the registered user',
    loginPasswordPreLabel: 'Confirm login password',
    loginPasswordPrePlaceholder: 'Please enter the login password again',
    fudPasswordLabel: 'Fund password',
    fudPasswordPlaceholder: 'Please enter the fund password',
    inviteCodeLabel: 'Invitation Code',
    inviteCodePlaceholder: 'Please enter a 6-digit invitation code',
    registerNeed: 'Continue to register means agree',
    registerArgument: '《Registration Agreement》',
    usernameRequired: 'Please enter a correct username',
    loginPasswordRequired: 'Please enter the correct login password',
    loginPasswordPreRequired: 'Please enter the correct confirmation login password',
    fundPasswordRequired: 'Please enter the correct fund password',
    inviteCodeRequired: 'Please enter the correct invitation code',
    diffLoginPasswordError: 'The two login passwords are inconsistent',
    registerSuccess: 'Successful registration',
    registerButton: 'Register',
    emailLabel: 'Email',
    emailPlaceholder: 'Please enter your email address',
    emailCodeLabel: 'Verification code',
    emailCodePlaceholder: 'Please enter your email verification code',
    second: 'second',
    getEmailCodeButton: 'Get code',
    emailRequired: 'Please enter a correct email address and try again',
    emailCodeRequired: 'Please enter the correct email verification code and try again'
  },
  home: {
    hotCoin: {
      title: 'Hot Deals',
      more: 'More'
    },
    poster: {
      title: 'Quick deposit',
      enter: 'Enter Now >',
      subTitle: 'Support BTC, USDT, ETH, etc.'
    },
    quickMenus: {
      futuresTrading: 'Futures Trading',
      helpCenter: 'Help Center'
    },
    ranking: {
      increase: {
        title: 'Rising list'
      },
      clinch: {
        title: 'Turnover List'
      }
    }
  },
  tabBar: {
    home: 'Home',
    price: 'Market',
    trade: 'Trade',
    fund: 'Asset',
    user: 'Profile'
  },
  currency: {
    favorite: 'Optional',
    allCurrency: 'Spot',
    dayVol: '24H',
    addFavor: '+ Add Favor'
  },
  trade: {
    bills: 'Bills',
    todayOpen: 'Open',
    star: 'Star',
    vol: 'Volume',
    low: 'Lowest',
    high: 'Highest',
    timing: 'Timing',
    spot: 'Futures',
    buyMore: 'Buy More',
    buyEmpty: 'Buy Empty',
    indicator: 'Indicator',
    indicatorSettings: 'Indicator Settings',
    balance: 'My balance',
    fee: 'Service fee',
    ruleIdError: 'Please select an expiration time',
    deleteFavoriteSuccess: 'Delete favorite currency successfully',
    addFavoriteSuccess: 'Add favorite currency successfully',
    buyIn: 'Buy',
    sellOut: 'Sell',
    holding: 'Holding',
    history: 'History',
    spotOrderConfirm: {
      title: 'Confirm Buy',
      amountPlaceholder: 'Please enter buy in count'
    },
    spotTradeOrder: {
      holding: {
        coin: 'currency',
        buyInAmountPrice: 'Buy Amount/Price',
        buyInCount: 'Quantity',
        actions: 'Operation',
        sellOut: 'Sell',
        profit: 'Profit'
      }
    },
    orderConfirm: {
      title: 'Order Confirm',
      coinName: 'Coin',
      direction: 'Direction',
      price: 'Price',
      balance: 'Balance',
      fee: 'Service Fee',
      buyMoreLabel: 'Buy More',
      buyEmptyLabel: 'Buy Empty',
      buyQuantity: 'Buy Quantity',
      buyAmount: 'Buy Amount',
      submit: 'Confirm order'
    },
    kline: {
      open: 'Open:',
      close: 'Close:',
      change: 'Change:'
    }
  },
  finance: {
    title: 'Finance'
  },
  allFinance: {
    title: 'Financial management',
    all: 'All'
  },
  financeOrders: {
    title: 'Pledge order',
    holdingLabel: 'Holding',
    historyLabel: 'History',
    holding: {
      amount: 'Pledge amount',
      rateStr: 'Income amount/yield',
      vcCount: 'Number of pledged coins',
      cycle: 'Position cycle',
      day: 'Day',
      calcStartDate: 'Start value date',
      serviceAmount: 'Service Fee',
      redeemOrder: 'Redeem'
    },
    history: {
      incomeAmount: 'Income amount',
      rateStr: 'Yield',
      amount: 'Pledge amount',
      vcCount: 'Number of pledged coins',
      calcStartDate: 'Start value date',
      calcEndDate: 'End Date',
      cycle: 'Cycle days',
      serviceAmount: 'Service Fee',
      day: 'day'
    }
  },
  financeOrderBills: {
    title: 'Pledge income bill',
    amount: 'Amount',
    balance: 'Balance'
  },
  financeItem: {
    rateStr: 'yield',
    buyType: 'Buy Type',
    cycle: 'cycle days',
    exchangeRate: 'Exchange rate (virtual currency exchange balance)',
    day: 'day',
    cycleType: 'cycle type',
    serviceRateStr: 'Service Rate'
  },
  buyFinance: {
    title: 'Buy',
    rateStr: 'yield',
    name: 'name',
    buyType: 'Buy Type',
    cycle: 'cycle days',
    cycleType: 'cycle type',
    exchangeRate: 'Exchange rate (virtual currency exchange balance)',
    serviceRateStr: 'Service Rate',
    remark: 'remark',
    buyAmountLabel: 'Buy Amount ({coin})',
    descriptionTitle: 'Product Description',
    descriptionPart1: '1. This product is a non-principal-guaranteed wealth management product. Market fluctuations may lead to principal losses. Please invest carefully.',
    descriptionPart2: '2. Payment settlement rules:',
    descriptionPart3: 'If the settlement price < linked price, BTC will be settled after maturity; settlement amount = investment amount * (1+ days * annualized rate of return / 365).',
    descriptionPart4: 'If the settlement price ≥ linked price, USDT will be settled after maturity; settlement amount = investment amount * linked price * (1+ days * annualized rate of return / 365).',
    descriptionPart5: '3. The actual annualized rate of return changes with the market in real time, please refer to the actual purchase transaction.',
    descriptionPart6: '4. The investment amount is converted according to the market in real time, please refer to the actual purchase transaction.',
    descriptionPart7: '5. After the product is purchased, it can be viewed on my currency holding page, and the refund will be automatically issued to the spot account after the expiration date.',
    buyButton: 'Buy [{coin}]'
  },
  fund: {
    description: 'Assets',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    exchange: 'Transfer',
    empty: 'Wallet is empty, go'
  },
  userCenter: {
    lastLogin: 'Last login',
    myTeam: 'My Team',
    identity: 'Authentication',
    walletAddress: 'Wallet address',
    zskAccount: 'ZSK Account',
    bankCard: 'Bank account',
    userBills: 'User Bills',
    timingTradeOrder: 'Timing Trade Order',
    spotTradeOrder: 'Futures Trade Order',
    contactTradeOrder: 'Contract position',
    userReport: 'User Report',
    teamReport: 'Team report',
    share: 'Share',
    customer: 'Customer service',
    helpCenter: 'Help Center',
    platform: 'Platform Introduction',
    profit: 'Profit',
    balance: 'Balance',
    withdraw: 'Withdraw',
    recharge: 'Recharge',
    creditStoreLabel: 'Credit Store'
  },
  settings: {
    title: 'Settings',
    fundPassword: 'Fund password',
    googleValidator: 'Google Validator',
    editLoginPassword: 'Edit Login Password',
    switchLocale: 'Switch language'
  },
  editFundPassword: {
    title: 'Change Fund Password',
    currentPasswordLabel: 'current password',
    currentPasswordPlaceholder: 'Please enter the current fund password',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Please enter the modified fund password',
    prePasswordLabel: 'Confirm password',
    prePasswordPlaceholder: 'Clear and re-enter the modified fund password',
    tips: 'The fund password is an important certificate for transactions, please set it carefully and keep it in mind',
    currentPasswordRequired: 'Please enter the current fund password',
    newPasswordRequired: 'Please enter the fund password to be modified',
    prePasswordRequired: 'Please enter the fund password to be modified again',
    prePasswordDiff: 'Two password inputs are inconsistent'
  },
  bindFundPassword: {
    title: 'Bind fund password',
    fundPasswordLabel: 'Fund Password',
    fundPasswordPlaceholder: 'Please input fund password',
    fundPasswordPreLabel: 'Confirm Password',
    fundPasswordPrePlaceholder: 'Please input fund password agagin',
    fundPasswordRequired: 'Fund password is required',
    fundPasswordPreRequired: 'Confirm password is required',
    fundPasswordDiff: 'Two password inputs are inconsistent',
    bindSuccess: 'Bind Success',
    tips: 'The fund password is an important certificate for transactions, please set it carefully and keep it in mind'
  },
  editLoginPassword: {
    title: 'Change login password',
    currentPasswordLabel: 'Current password',
    currentPasswordPlaceholder: 'Please enter the current login password',
    newPasswordLabel: 'New Password',
    newPasswordPlaceholder: 'Please enter the modified login password',
    prePasswordLabel: 'Confirm password',
    prePasswordPlaceholder: 'Clear and re-enter the modified login password',
    tips: 'The login password is an important credential for login authentication, etc., please set it carefully and keep it in mind',
    currentPasswordRequired: 'Please enter the current login password',
    newPasswordRequired: 'Please enter the login password to be modified',
    prePasswordRequired: 'Please re-enter the login password to be modified',
    prePasswordDiff: 'Two password inputs are inconsistent'
  },
  bindGoogleValidator: {
    title: 'Bind Google Authenticator',
    qrCodeLabel: 'QR code',
    keyLabel: 'Key',
    loginPasswordLabel: 'Login password',
    loginPasswordPlaceholder: 'Please enter your login password',
    googleCodeLabel: 'Google verification code',
    googleCodePlaceholder: 'Please enter a 6-digit Google verification code',
    tipsPart1: 'Search Google Authenticator in the app store',
    tipsPart2: 'Use Google Authenticator to scan the QR code above, or manually enter the key for binding',
    tipsPart3: 'Enter the 6-digit Google verification code above, click Confirm to submit',
    loginPasswordRequired: 'Please enter the login password',
    googleCodeRequired: 'Please enter a 6-digit Google verification code'
  },
  walletAddress: {
    title: 'Wallet Address',
    add: '+ Add Address',
    remark: 'Remark',
    addButton: 'Add wallet address',
    tips: 'If you want to modify or delete address information, please contact customer service'
  },
  addWalletAddress: {
    title: 'Add wallet address',
    vcChainNameIdLabel: 'Chain type',
    vcAccountLabel: 'Wallet address',
    vcAccountPlaceholder: 'Please enter wallet address',
    remarkLabel: 'Remarks',
    remarkPlaceholder: 'Please enter the remark content',
    fundPasswordLabel: 'Fund Password',
    fundPasswordPlaceholder: 'Please enter your fund password',
    tips: 'The added wallet address cannot be modified, please verify that the information is correct',
    vcIdRequired: 'Please select the correct currency',
    vcChainNameIdRequired: 'Please select the correct chain type',
    vcAccountRequired: 'Please enter the correct wallet address',
    fundPwdRequired: 'Please enter the correct fund password',
    addSuccess: 'Wallet address added successfully'
  },
  receiveWays: {
    title: 'My Bank Card',
    add: '+ Add bank card',
    tips: 'If you want to modify or delete bank card information, please contact customer service',
    addCardButton: 'Add bank card'
  },
  zskAccount: {
    title: 'Fast account',
    add: '+ Add fast account',
    tips: 'To modify or delete account information, please contact customer service',
    addCardButton: 'Add account'
  },
  addZskAccount: {
    title: 'Add a fast account',
    withdrawNameLabel: 'Name',
    withdrawNamePlaceholder: 'Please enter name',
    withdrawNameRequired: 'Name is required',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Please enter the fast speed',
    fundPasswordLabel: 'Fund password',
    fundPasswordPlaceholder: 'Please enter your fund password',
    tips: 'Please carefully fill in the information of the added account, the company will not be responsible for the problem that the withdrawal fails to arrive due to incorrect information'
  },
  addBankCard: {
    title: 'Add a new bank card',
    withdrawNameLabel: 'Name',
    withdrawNamePlaceholder: 'Please enter name',
    withdrawNameRequired: 'Name is required',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Please enter ZSK',
    zskRequired: 'ZSK is required',
    cardNumLabel: 'Bank account number',
    cardNumPlaceholder: 'Please enter the bank card number',
    branchLabel: 'Branch address',
    branchPlaceholder: 'Please enter the bank card branch address',
    fundPasswordLabel: 'Fund password',
    fundPasswordPlaceholder: 'Please enter the fund password',
    tips: 'The bank card is an important data for transaction cash withdrawal, please fill in carefully, the company will not be responsible for any problems such as failure to receive cash due to incorrect card information filling. ',
    backIdRequired: 'Please select the account bank',
    cardNumRequired: 'Please enter the correct bank card number',
    fundPwdRequired: 'Please enter the correct fund password',
    idCardPlaceholder: 'Please enter your ID number',
    idCardLabel: 'ID card number',
    idCardRequired: 'Please enter the correct ID number',
    cciPlaceholder: 'Please enter CCI',
    branchCodePlaceholder: 'Please enter branch code',
    branchCodeLabel: 'Branch code',
    katakanaPlaceholder: 'Please enter katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Account Change Record',
    vcName: 'Currency',
    amount: 'Amount',
    balance: 'Balance'
  },
  timingTradeOrder: {
    title: 'Timing trade order',
    waiting: {
      title: 'Orders in progress',
      amount: 'Amount',
      period: 'period',
      receivePrice: 'Buy price',
      settlement: 'settlement in progress'
    },
    history: {
      title: 'Historical Orders',
      buyInClose: 'Buy price',
      saleOutClose: 'sale price'
    }
  },
  spotTradeOrder: {
    title: '期货交易订单',
    waiting: {
      title: '在持订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      buyInTime: '买入时间'
    },
    history: {
      title: '历史订单',
      buyInAmount: '买入总价',
      buyInPrice: '买入单价',
      buyInCount: '买入数量',
      sellOutAmount: '卖出总价',
      sellOutPrice: '卖出单价',
      sellOutTime: '卖出时间'
    }
  },
  userReport: {
    title: 'User Report',
    profit: 'Profit',
    timingTradeAmountFee: 'Extremely fast trading order/handling fee',
    timingTradePrizePoint: 'Extremely fast trading bonus/rebate',
    rechargeInfo: 'Recharge/handling fee',
    withdrawInfo: 'Withdrawal/handling fee',
    exchangeInfo: 'Exchange/handling fee'
  },
  userReportDay: {
    title: 'User Daily Report',
    profit: 'Profit',
    timingTradeAmountFee: 'Extremely fast trading order/handling fee',
    timingTradePrizePoint: 'Extremely fast trading bonus/rebate',
    rechargeInfo: 'Recharge/handling fee',
    withdrawInfo: 'Withdrawal/handling fee',
    exchangeInfo: 'Exchange/handling fee'
  },
  teamReport: {
    goToReportDay: 'Report Day',
    timingTradeBetAmountServiceCharge: 'Timing Trade Amount/Services',
    timingTradeBetPrizePoint: 'Timing Trade Prize/Point',
    timingTradeUserAndCount: 'Timing Trade Users/Counts',
    rechargeAmountFee: 'Recharge Amount/Services',
    rechargePersonCount: 'Recharge Users/Counts',
    withdrawAmountFee: 'Withdraw Amount/Services',
    withdrawPersonCount: 'Withdraw Users/Counts',
    firstRechargeUserAndCount: 'First Recharge Amount/Counts',
    title: 'Team Report',
    usernamePlaceholder: 'Enter the lower-level username',
    previewAllTradeInfo: 'View all speed trade information',
    coin: 'currency',
    timingTradeBetAmount: 'Extremely fast trading betting amount',
    profit: 'Profit',
    action: 'operation',
    previewReportDay: 'View the daily report'
  },
  teamTimingTradeInfo: {
    title: 'Team Speed Trading',
    profit: 'Profit',
    subTitle: 'Team speed transaction information',
    timingTradeAmountFee: 'Extremely fast trading order/service fee',
    timingTradePrizePoint: 'Extremely fast trading bonus/rebate',
    rechargeInfo: 'Recharge/Service Fee',
    withdrawInfo: 'Withdrawal/Service Fee',
    exchangeInfo: 'Exchange/Service Fee'
  },
  teamReportDay: {
    title: 'Team Daily Report',
    subTitle: 'Team [ {username} ] Daily Report',
    timingTradeBetAmountFee: 'Extremely fast trading order/service fee',
    timingTradeUserAndCount: 'Timing Trade Users/Counts',
    timingTradeBetPrizePoint: 'Fast Trading Bonus/Rebate',
    rechargeAmountFee: 'Recharge amount/service fee',
    rechargePersonCount: 'Recharge person/number of transactions',
    firstRechargePersonCount: 'First Recharge Amount/Counts',
    withdrawAmountFee: 'Withdrawal amount/service fee',
    withdrawPersonCount: 'The number of people withdrawing money/transactions',
    exchangeAmountFee: 'Exchange Amount/Service Fee'
  },
  share: {
    title: 'Share',
    qrCodeLabel: 'QR code',
    registerUrlLabel: 'Registration address',
    inviteCodeLabel: 'Invitation Code',
    hasNoInviteCode: 'The current account has no invitation code,',
    generateInvitationCode: 'Try to generate with one click',
    tipsPart1: 'Scan the above QR code to fill in the registration information to register',
    tipsPart2: 'Copy the registration address and fill in the registration information to register',
    tipsPart3: 'Manually open the registration interface of this site and fill in the invitation code to register',
    saveImageError: 'Failed to save the picture, try to long press the picture and save'
  },
  myTeam: {
    title: 'My Team',
    usernamePlaceholder: 'Enter the lower-level username',
    point: 'rebate (speed/contract)',
    totalBalance: 'Balance',
    lastLoginTime: 'Last Login Time',
    noLoginTime: 'none'
  },
  userDetail: {
    title: 'User Detail',
    username: 'Username',
    userType: 'User Type',
    pointPercentTiming: 'Timing Point',
    pointPercentContract: 'Contract Point',
    registerWay: 'Registration method',
    teamCounts: 'Team number',
    teamOnline: 'team online',
    balance: 'Balance',
    registerTime: 'Registration time',
    onlineStatus: 'login status'
  },
  addUser: {
    title: 'Add User',
    addUserDirect: {
      userTypeLabel: 'User Type',
      usernameLabel: 'Username',
      usernamePlaceholder: 'Please enter the account username',
      pointTimingLabel: 'Extremely fast transaction rebate',
      pointContractLabel: 'Contract transaction rebate',
      tips: 'The initial password is: "{password}"; please remind the user to change the password in time after opening the account',
      userTypeRequired: 'Please select the account type',
      usernameRequired: 'Please enter the account username',
      pointTimingRequired: 'Please select the fast transaction rebate',
      pointContractRequired: 'Please select contract transaction rebate',
      copyTemplate: `
         Username: {username};
         Login password: {loginPassword};
         Login URL: {loginAddress};
         Fast trading rebate: {timingTradePoint};
         Contract trading rebate: {contactTradePoint};
         `
    }
  },
  recharge: {
    title: 'Recharge',
    configIdLabel: 'Recharge channel',
    chainNameLabel: 'Chain name',
    amountLabel: 'Deposit Amount',
    userCardNameLabel: 'Payer',
    userCardNamePlaceholder: 'Please enter the name of the payer',
    fee: 'service fee',
    receiveAmountTipsPart1: 'Recharge',
    receiveAmountTipsPart2: ', Need pay',
    tipsPart1: 'Because the online payment interface is unstable, only offline transfer and recharge are currently supported! ',
    tipsPart2: 'Please fill in the actual transfer amount truthfully, otherwise it may cause the system to fail the review and affect the recharge progress. ',
    emptyPart1: 'No Recharge Channel, ',
    emptyPart2: 'Tap to retry',
    amountRequired: 'The recharge amount cannot be empty',
    maxPrecisionError: 'The recharge amount can have up to {amountMaxPrecision} decimal places',
    payUserNameError: 'Please enter a correct payer and try again',
    userMobileLabel: 'Mobile',
    userMobilePlaceholder: 'Please input your mobile',
    needPayLabel: 'Need Pay',
    needPayPlaceholder: 'Please Input Amount'
  },
  payDetail: {
    title: 'Transfer Information',
    addressLabel: 'Deposit address',
    rechargeAmount: 'Amount',
    bankNameLabel: 'Bank',
    branchLabel: 'Branch address',
    cardName: 'Name',
    cardNum: 'card number',
    uploadImgLabel: 'Payment Credentials',
    uploadImgPlaceholder: 'Click to upload payment voucher image',
    uploadImgRequired: 'Please upload payment voucher picture',
    vcTransferTipsPart1: '1. Copy the deposit address or scan the QR code to deposit',
    vcTransferTipsPart2: '2. Upload the payment voucher picture after the deposit is completed',
    vcTransferTipsPart3: 'In order to improve the efficiency of deposit, please make sure to upload a clear and high-definition certificate picture, if the relevant information picture is not clear, it may cause the system to fail the review and affect the deposit progress. ',
    bankCardTips: 'In order to improve the efficiency of depositing money, please make sure that the name of the transferor and the remitter are the same; if the relevant information does not match, it may cause the system to fail the review and affect the progress of the deposit. ',
    bankCardTransferSuccess: 'I have transferred successfully'
  },
  rechargeOrder: {
    title: 'Deposit order',
    payAmount: 'Amount',
    receiveAmount: 'Receive Amount'
  },
  identity: {
    title: 'Real name information',
    subTitle: 'Real-name authentication includes information authentication, identity authentication',
    name: 'Name',
    idType: 'Document type',
    idNum: 'ID number',
    demand: 'Require',
    informationVer: 'Information Verification',
    idAuthentication: 'Authentication',
    material: 'Material'
  },
  verified: {
    title: 'Verified',
    idCardTypeLabel: 'Certificate type',
    idCardFrontSideImgLabel: 'Card Front SideImgLabel',
    idCardBackSideImgLabel: 'The back of the ID photo',
    idCardHandSideImgLabel: 'Hand-held ID photo',
    nameLabel: 'Document name',
    namePlaceholder: 'Please enter your ID name',
    idCardNumLabel: 'ID card number',
    idCardNumPlaceholder: 'Please enter the ID number',
    fundPwdLabel: 'Fund password',
    fundPwdPlaceholder: 'Please enter your fund password',
    tips: 'Once the information authentication is submitted, it cannot be modified, please check it carefully and fill it in correctly',
    idCardTypeRequired: 'Please select the card type',
    idCardFrontSideImgRequired: 'Please upload a front photo of the ID card',
    idCardBackSideImgRequired: 'Please upload a photo of the back of the ID card',
    idCardHandSideImgRequired: 'Please upload a hand-held ID photo',
    nameRequired: 'Please enter the name of the document',
    idCardNumRequired: 'Please enter the ID number',
    fundPwdRequired: 'Please enter your fund password',
    submitSuccess: 'Authentication request submitted successfully'
  },
  help: {
    title: 'Help Center'
  },
  helpDetail: {
    title: 'Help Details'
  },
  myMessage: {
    title: 'My Message'
  },
  messageDetail: {
    title: 'Message details'
  },
  withdraw: {
    title: 'Withdraw coins',
    tips: 'In order to ensure the safety of funds and the efficiency of withdrawal; please carefully check that the information filled in is correct, the services fee generated during the withdrawal process will be deducted from the balance',
    receiveAmountTipsPart1: 'Withdraw',
    receiveAmountTipsPart2: ', expected to arrive',
    fee: 'Service fee',
    myBalance: 'My [{vcName}] balance:',
    configIdLabel: 'Withdrawal channel',
    amountLabel: 'Withdrawal amount',
    fundLabel: 'Fund password',
    fundPlaceholder: 'Please enter your fund password',
    googleCodeLabel: 'Google verification code',
    googleCodePlaceholder: 'Please enter a 6-digit Google verification code',
    maxPrecisionError: 'The withdrawal amount can have up to {amountMaxPrecision} decimal places',
    amountRequired: 'Please enter or select the correct withdrawal amount',
    bankCardError: 'Please select the correct bank card',
    fundPwdError: 'Please enter the correct fund password',
    walletAddressError: 'Please select the correct wallet address',
    success: 'The withdrawal request was submitted successfully, please wait for processing',
    emptyPart1: 'There is no withdrawal channel available, ',
    emptyPart2: 'Tap to retry'
  },
  withdrawOrder: {
    title: 'Withdrawal order',
    requestAmount: 'Amount',
    receiveAmount: 'Receive Amount'
  },
  locales: {
    title: 'Switch language'
  },
  lines: {
    title: 'Lines',
    switchLine: 'Switch Line'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Delete favorite currency successfully',
    addFavoriteSuccess: 'Add favorite currency successfully'
  },
  currencySelect: {
    currencyName: 'currency',
    currencyPlaceholder: 'Click to select currency'
  },
  walletItem: {
    available: 'available',
    convert: 'convert (USDT)'
  },
  banks: {
    bankIdLabel: 'Bank',
    bankIdPlaceholder: 'Click to select a bank'
  },
  banksPop: {
    title: 'Select Bank',
    search: 'Input bank keywords'
  },
  historyOrderDetail: {
    title: 'Order Details',
    coin: 'Transaction currency',
    amount: 'order amount',
    buyInClose: 'Buy price',
    sellOutClose: 'Sell price',
    isQuest: 'Have any questions about this order?',
    connectCustomer: 'Contact customer service?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Click to select user rebate'
  },
  walletAddressSelect: {
    title: 'Select wallet address',
    label: 'Wallet address',
    placeholder: 'Click to select wallet address'
  },
  myCardSelect: {
    title: 'Select account',
    label: 'receiving account',
    placeholder: 'Click to select an account'
  },
  amountInput: {
    amountRange: 'Min {minAmount}, Max {maxAmount}',
    amountMin: 'Min {minAmount}, Uncapped',
    amountErrorEmpty: '{label} is required',
    amountErrorOutRange: '{label} is out of range'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Min {minAmount}, Uncapped',
    placeholderHasMax: 'Min {minAmount}, Max {maxAmount}',
    amountErrorEmpty: 'The amount is incorrect',
    amountErrorOutRange: 'The amount is out of range'
  },
  common: {
    remark: 'Remark',
    saveImage: 'Save Image',
    online: 'Online',
    offline: 'Offline',
    profit: 'Profit',
    date: 'Date',
    period: 'Period',
    pointAmount: 'Point Amount',
    point: 'User rebate',
    direction: 'Direction',
    winLoss: 'Income',
    lose: 'Lose',
    add: 'Add',
    win: 'Win',
    edit: 'Modify',
    notBind: 'Unbound',
    alreadyBind: 'Already Bound',
    enabled: 'Enabled',
    notEnabled: 'NotEnabled',
    queryRange: 'Query Range',
    copy: 'Copy',
    orderNum: 'Order',
    null: 'Null',
    noData: 'No Data',
    refreshSuccess: 'Refresh Success',
    loadMoreData: 'Load more data',
    noMoreData: 'No more data',
    lookMore: 'More',
    more: 'More'
  },
  date: {
    today: 'Today',
    yesterday: 'Yesterday',
    last7Days: 'Nearly 7 days',
    last14Days: 'Nearly 14 days',
    split: 'To'
  },
  button: {
    save: 'Save',
    logout: 'Logout',
    confirm: 'OK',
    cancel: 'Cancel',
    submit: 'Submit',
    addNow: 'Add now',
    reset: 'reset',
    nextStep: 'Next',
    goCertification: 'Go to certification'
  },
  confirm: {
    title: {
      logout: 'Logout',
      unBindFundPassword: 'Unbound fund password',
      addUserDirect: 'Add User',
      addUserInfo: 'Add user successfully',
      jumpToRechargePage: 'Confirm Jump',
      unAuthentication: 'Un authentication',
      noBindBankCard: 'No bank card',
      noBindCoinAddress: 'No wallet address',
      tradeConfirm: 'Confirm transaction',
      sellOutSpotOrder: 'Position to sell',
      buyFinance: 'Confirm Purchase',
      redeemOrder: 'Pledge order redemption'
    },
    content: {
      logout: 'Are you sure to log out of the current account?',
      unBindFundPassword: 'An unbound fund password has been detected, to ensure account security, please bind your fund password first',
      addUserDirect: 'A new user will be added soon, please verify that the information is correct and click OK to continue, user name [ {username} ], user type [ {userType} ], login password [ {password} ], and the difference between my speed trading rebate [ {diffPointTiming} ], and my contract transaction rebate difference [ {diffPointContract} ]',
      addUserInfo: 'Username [ {username} ]; <br /> Login password [ {password} ];<br /> Login URL [ {loginAddress} ];<br /> Extreme transaction rebate [ {pointPercentTiming} ];<br /> /> Contract transaction rebate [{pointPercentContract}];',
      jumpToRechargePage: 'About to jump to the three-party recharge interface, please click confirm to continue',
      unAuthentication: 'It is detected that the account has not undergone real-name authentication. In order to ensure the normal circulation of funds, please perform real-name authentication first',
      noBindBankCard: 'It is detected that the account is not bound or activated with a bank card. In order to ensure the normal circulation of funds, please bind the bank card first',
      noBindCoinAddress: 'It is detected that the account has no bound or enabled virtual currency account. In order to ensure the normal circulation of funds, please add the virtual currency account address first',
      tradeConfirm: 'The order is about to be submitted, please verify the order information is correct and click Confirm Order to submit',
      sellOutSpotOrder: 'The position order is about to be sold, please confirm that the operation is correct and click OK to continue',
      buyFinance: 'About to buy [{coin}], buy share: {amount}, please confirm that the operation is correct and click OK to continue',
      redeemOrder: 'The pledge order ({orderNum}) is about to be redeemed, please confirm that the operation is correct and click Confirm to continue'
    }
  },
  message: {
    bindSuccess: 'Bind successfully',
    successOperation: 'Operation succeeded',
    logoutSuccess: 'Exit successfully',
    editSuccess: 'Modified successfully',
    addSuccess: 'Add successfully',
    copySuccess: 'Copy success',
    copyFailed: 'Copy failed'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Day',
      week_day_1: 'One',
      week_day_2: 'two',
      week_day_3: 'three',
      week_day_4: 'four',
      week_day_5: 'five',
      week_day_6: 'Six'
    },
    loading: {
      loading: 'loading'
    }
  },
  helpItems: {
    title: {
      part1: 'Why does the converted amount in assets change? ',
      part2: 'Forgetting the fund password handling method for OTC transactions',
      part3: 'Where will the funds flow after the OTC transaction purchase is completed? ',
      part4: 'Why do you want to limit the number of times you can modify your nickname',
      part5: 'What is the meaning of transfer, why is it necessary to transfer',
      part6: 'How to calculate the account equity of the user contract? ',
      part7: 'What is the value of the stop loss and take profit set in the opening position? How should it be set? ',
      part8: 'How to reduce contract risk? ',
      part9: 'What does the quantity in the contract open position indicate? ',
      part10: 'Instructions on forced liquidation',
      part11: 'What are the contract trading rules? ',
      part12: 'What is the margin in contract trading? ',
      part13: 'What is limit order and market order? ',
      part14: 'What does the risk of contract transactions represent',
      part15: 'Why do you need currency conversion? ',
      part16: 'Why did the other party not receive the transfer in time after the OTC transaction transfer? ',
      part17: 'How to buy Tether (USDT) through OTC? '
    },
    content: {
      part1: 'The value of digital currency currently held in Renminbi when converted into assets will change due to price fluctuations of digital assets. The number of your digital assets has not changed. ',
      part2: 'If you forget the OTC transaction fund password, please go to "My-Settings-Click to set the fund password" or contact customer service to reset',
      part3: 'After the OTC buy order is completed, the funds will enter the legal currency account in the asset. If you need to use OTC purchased assets for contract trading or futures trading, please go to the fund transfer module to transfer. ',
      part4: 'For the security reasons of your transaction, we currently limit the nickname to be modified only once. ',
      part5: 'In order to ensure the independence of funds between your various accounts and to facilitate your reasonable risk control, the accounts of the major trading modules are hereby divided. Transfer refers to the process of mutual conversion of assets between various trading accounts. ',
      part6: '<p>Contract account equity, the calculation method is as follows:</p> <p>Contract account equity = position margin + position floating profit and loss + current account available amount</p>',
      part7: 'Take profit and stop loss are the profit limit and loss limit set by you. When the set stop profit and stop loss amount is reached, the system will automatically close the position. It can be used for your risk control when purchasing contracts. Half of the set take profit amount is: increase amount x quantity x leverage multiple, and set stop loss. We recommend that you set it according to your actual asset situation to reasonably control risks. ',
      part8: 'You can transfer the available assets of the remaining accounts to the contract account by transferring funds, or reduce the risk by reducing the position. ',
      part9: 'The quantity in the open position indicates the quantity of currency you expect to buy. For example: on the opening page of the BTC/USDT trading pair, choose to buy long, enter the price as 1000USDT, and enter the quantity as 10BTC, which means: you expect to buy 10 BTC with a unit price of 1000USDT. ',
      part10: '<p>The risk degree is an indicator to measure the risk of your assets. When the risk degree is equal to 100%, your position is considered liquidated. The risk degree=(position margin/contract account equity)*100%, in order To prevent users from overrunning their positions, the system sets the adjustment ratio of the risk degree. When the risk degree reaches the risk value set by the system, the system will force liquidation. For example: if the adjustment ratio set by the system is 10%, then when your risk degree is greater than or equal to 90%, all your positions will be forcibly closed by the system. </p> <p>Note: If the system forces liquidation caused by excessive risk, all your positions will be closed, so I hope you can reasonably control your risk to avoid unnecessary losses< /p>',
      part11: '<p>Trade type</p> <p>Trade type is divided into two directions: open long position (buy) and open short position (sell):</p> <p>Buy long (Calling) means that you believe that the current index may rise, and hope to buy a certain amount of certain contracts at the price you set or the current market price. </p> <p>Short selling (bearish) means that you believe that the current index may fall, and hope to sell a certain number of certain contracts at the price you set or the current market price. </p> <p>How to place an order</p> <p>Limit order: you need to specify the price and quantity of the order</p> <p>Market order: you only need to set the quantity of the order, The price is the current market price</p> <p>Position</p> <p>When the opening order you submit is completed, it is called a position</p> <p>Contract delivery issues</p> < p>The platform contract is a perpetual contract with no set delivery time. As long as the system liquidation conditions are not met or you do not close the position manually, you can hold the position permanently. </p> <p>The system closes the position</p> <p>1: The system automatically closes the position when the set value of stop profit and stop loss is reached</p> <p>2: The risk is too high, the system forces the position to be closed< /p>',
      part12: '<p>In the contract transaction, the user can participate in the transaction of the contract by paying funds as the financial guarantee for the performance of the contract according to the contract price and quantity, according to the corresponding leverage multiple, and this fund is the contract margin. The user will occupy the margin when opening a position, and the more the margin for opening a position is occupied, the higher the risk of the account. </p> <p>Margin = (opening price * quantity) / leverage ratio</p>',
      part13: 'Limit order refers to the price you expect to entrust the platform to conduct transactions, and market order refers to directly entrust the platform to conduct transactions at the current price. In the rules for opening positions, market orders are prioritized over limit orders. If you choose a limit order, please open a position reasonably according to the market price of the current currency to avoid losses caused by unreasonable opening prices. ',
      part14: 'Risk level is the risk indicator in your contract account, and risk level equal to 100% is considered liquidation. We suggest that you, when your risk exceeds 50%, you need to open positions carefully to avoid losses due to liquidation. You can reduce your risk by replenishing the available funds of contract assets, or reducing positions. ',
      part15: 'The function of the exchange is to allow the smooth circulation of funds in different currencies in your assets, and the QCC obtained in the futures account can be freely converted into USDT for trading. USDT in other accounts can also be freely converted into QCC for transactions. ',
      part16: 'First of all, please make sure that the payment method you fill in when transferring money is exactly the same as that displayed on the order details page. Then please confirm whether your payment method is instant or delayed. Finally, please contact your bank and payment institution for system maintenance or other reasons. ',
      part17: '<p>Method 1: Select the order you want to buy through the OTC buy and sell list to buy or sell. </p> <p>Method 2: Click the publish button to publish buy or sell orders according to your needs for quick transactions. The system will quickly match you with buyers and sellers. </p> <p>Note: If the purchase order is not paid after 15 minutes, the system will automatically cancel the order, please pay in time. If the order is canceled more than 3 times on the same day, the transaction cannot be carried out again on the same day, and the trading authority will be restored on the next day. </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/en.js